import { render, staticRenderFns } from "./IndexTabBar.vue?vue&type=template&id=c066df76&scoped=true&"
import script from "./IndexTabBar.vue?vue&type=script&lang=js&"
export * from "./IndexTabBar.vue?vue&type=script&lang=js&"
import style0 from "./IndexTabBar.vue?vue&type=style&index=0&id=c066df76&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c066df76",
  null
  
)

export default component.exports